import { usePageBySlug } from "@/hooks/usePagesDB";
import StaticPageRenderer from "@/components/feature/StaticPageRenderer";
import NotFound from "../NotFound";

export default function DatenschutzPage() {
  const { page } = usePageBySlug("datenschutz");
  if (!page) return null;
  if (!page.isPublished) return <NotFound />;

  return <StaticPageRenderer page={page} />;
}